import axios from 'axios';

import {
  axiosHeaderV2,
  getV2RootUrl,
  publicAxiosHeaderV2
} from 'common/helpers/apiHelper';
import { doesCustomerExist } from 'common/helpers/customerHelper';

export const contactUsForm = (data) =>
  axios.post(`${getV2RootUrl()}/form/contact-us`, data, publicAxiosHeaderV2());

export const subscribeForm = (data) =>
  axios.post(
    `${getV2RootUrl()}/customer/subscribe`,
    data,
    publicAxiosHeaderV2()
  );

export const getForm = (code) =>
  axios.get(
    `${getV2RootUrl()}/form/code/${code}/for-web`,
    publicAxiosHeaderV2()
  );

export const submitForm = (response, formId) => {
  if (doesCustomerExist()) {
    return axios.post(
      `${getV2RootUrl()}/form/${formId}/response`,
      response,
      axiosHeaderV2()
    );
  }
  return axios.post(
    `${getV2RootUrl()}/form/${formId}/response`,
    response,
    publicAxiosHeaderV2()
  );
};
